// extracted by mini-css-extract-plugin
module.exports = {"commonBadge":"styles-module__commonBadge___2xLU_","blueBadge":"styles-module__blueBadge___23OZZ","redBadge":"styles-module__redBadge___3RZbA","gray":"styles-module__gray___31R8w"};